import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromNotebookSecret from './notebook-secret.reducer';

export const selectNotebookSecretState = createFeatureSelector<fromNotebookSecret.NotebookSecretState>(
  fromNotebookSecret.notebookSecretFeatureKey
);
export const selectSecrets = createSelector(selectNotebookSecretState, (state) => state.secrets);

export const selectSecretKeys = createSelector(selectNotebookSecretState, (state) =>
  state.secrets.map((secret) => secret.key)
);

export const isSecretsExist = createSelector(selectNotebookSecretState, (state) => !!state.secrets.length);

export const loadDatasetError = createSelector(selectNotebookSecretState, (state) => state.loadSecretError);
